import React, { Fragment, useState } from 'react'
import axios from 'axios'

import { Modal, ModalHeader, ModalBody, Button, Alert } from 'reactstrap'

import { Scanner } from '@yudiel/react-qr-scanner';
import { tokenConfig } from '../../utils/apiConfig';

const QrScanner = props => {
    const [modal, setModal] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [counter, setCounter] = useState(0)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const toggle = () => {
        setModal(!modal)
    }

    const handleScan = async (detectedCodes = []) => {
        const scannedData = detectedCodes[0]?.rawValue

        if (!scannedData || isSubmitting) {
            return
        }

        setIsSubmitting(true)
        setErrorMessage("")
        setSuccessMessage("")

        try {
            const res = await axios.patch('/api/registrations/qrscan', { _id: scannedData }, tokenConfig())
            props.updateStatus(scannedData)
            setCounter(prevCounter => prevCounter + 1)
            setSuccessMessage(`${res.data?.registration?.guests ? res.data.registration.guests.length + 1 : '1'} attendees ${res.data.message}`)
        } catch (err) {
            setErrorMessage(err.response?.data || 'Unable to scan QR code')
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <Fragment>
            <Button color='primary' onClick={toggle}>Scan Qr</Button>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Qr Scanner</ModalHeader>
                <ModalBody>
                    {errorMessage && <Alert color='danger'>{errorMessage}</Alert>}
                    {successMessage && <Alert color='success'>{successMessage}</Alert>}
                    <Scanner
                        allowMultiple
                        constraints={{ facingMode: 'environment' }}
                        formats={['qr_code']}
                        onError={err => console.log(err)}
                        onScan={handleScan}
                        scanDelay={750}
                        styles={{ container: { width: "100%" } }}
                    />
                </ModalBody>
                <p>{counter}</p>
            </Modal>

        </Fragment>
    )
}

export default QrScanner
